module.exports = __webpack_public_path__ + "img/youtube.284c8c8.svg";